var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new"},[_c('div',{staticClass:"zlAssess"},[_c('ZlContent',{attrs:{"list":_vm.list}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }